const history = {
    title: "History of the BUIHA",
    mdcontent: `
    

## Overview

The British Universities Ice Hockey Association (BUIHA), founded in 2003, is the governing body for University Ice Hockey in Great Britain.
Before this there were only a small number of university Ice Hockey teams largely playing against Recreational Clubs on an ad-hoc basis.
\n
The BUIHA now has an annual membership of over 1000 players, representing over 50 universities and colleges from across the UK as part of over 20 clubs.
\n
Each year we run the Cup Competition across North and South, Checking and Non-Checking Divisions and BUIHA Nationals, 
A tournament bringing together every team in the country to compete over 3 weekends in Sheffield to be crowned National Champions. 
Recently these competitions have been expanded to include a Women's Cup and Women's Nationals
\n
The BUIHA also oversees the Great Britain Students (GBS) program in collaboration with BUCS and Ice Hockey UK to enter the FISU World University Games.
\n

## Pre-Foundation & First Nationals

The first National Championships for university teams was organised by Alexis Rawlinson, then Secretary of the Oxford Vikings. 
It all began over a couple of pints one rainy afternoon in Oxford, the precise details of which are lost to time. 

\n
Oxford Ice Rink was booked for a tournament which started at 11pm and ran all the way through to the morning, resulting in a narrow Newcastle victory.
This brought together 5 teams (with Blues teams not invited as they were above the standard of the others). 

\n
Motivated by his team’s success in winning the first-ever tournament, Newcastle University student Graham Brewer, 
took over organising the event in 2001/02, at the National Ice Centre in Nottingham. 

\n
In the 02-03 season, Graham work with Simon Hopkins, who worked at University of Nottingham Sport, to organise this year's event.


## Foundation
In 2003, Simon Hopkins worked with Russell Ellis (from the University of London Union Purples) to formally create the BUIHA. 
The National Championships moved to the newly constructed IceSheffield rink for the 2003/04 season. 
\n
A Cup Competition was established in 2003 to run throughout the academic year (Oct-Mar), initially in a round robin format, with the annual National Championships held in April. 
The Cup Competition proved to be very successful and encouraged the development of new clubs and teams across the UK.
\n
From the 2008/09 season, the BUIHA was given permission to create their own Universities Section, answering directly to EIHA Board of Directors. 
\n
This bold move away from the Recreational Sections of the EIHA & SIHA created greater flexibility and allowed the BUIHA Executive Committee 
to develop a bespoke online registration management and fixtures systems in addition to social media, a website and livestreaming platforms 
which became the benchmark for similar developments throughout Ice Hockey in the UK.
\n

## Cup Competition

Created in Autumn 2004 by the founding BUIHA committee the cup competition was envisioned as a league-style cup competition available to university clubs in the UK.
\n
Originally there were 2 divisions, consisting of:
\n
- Division 1
    - Cambridge University Blues (Winners)
    - University of London Union Purples
    - Nottingham Mavericks A
- Division 2
    - Cambridge University Eskimos
    - Imperial College Devils
    - Newcastle University Wildcats (Winners)
    - Oxford University Vikings
    - Nottingham Mavericks B
    - University of Warwick Panthers

The Cup Competition has expanded to over 8 divisions across the North and the South with teams competing in a double round-robin format. 
The winners of the top checking and non-checking divisions in the North and South compete for the division championship title at Nationals of each season.

## Great Britain Students (Team GBS)

In 2005, Simon Hopkins created the Great Britain Universities (Men’s) Ice Hockey Team (GBU) as a platform for the British students to experience representing their nation and respective universities in Ice Hockey at the FISU World University Games (WUG). 
\n
This event is renowned globally as being second only to the Olympic Winter Games, and has seen GBU play against some of the top Ice Hockey nations in the world (e.g. Canada, Czech Rep, Finland and Russia). 
After GBUs inaugural WUGs in Torino (Italy) the GBU Women’s team was created for Harbin 2009. 
The Women's team was managed by Ice Hockey UK until 2017/18. The BUIHA now operates both GBU Men and GBU Women autonomously.
\n
GBU is now recognised as an integral step in the Ice Hockey UK Performance Pathway, placed between the GBU18s/20s and the Senior teams. 
Notably, a number of GBU players have gone on to play professional Ice Hockey in the Elite Ice Hockey League (EIHL), 
and both GBU-M and GBU-W players currently feature prominently in the GB Senior Ice Hockey teams, playing at IIHF World Championships.

Prior to the global pandemic, the BUIHA created International All-Star teams (Men and Women) as a platform for the many 
international students studying in the UK to come together once per season to play in exhibition games versus the GBU Men and GBU Women. 
\n
This event helps to promote universities Ice Hockey in the UK to international students in addition to providing a good calibre competition and 
natural friendly rivalry for the GBU teams in their preparation for the biannial WUGs.

## Looking to the future
In 2018 the BUIHA was heavily involved in the NGBs Ice Hockey Development Plan and Governance Review to support the future proper management of Ice Hockey in the UK. 
This lead to an increase in the number of players, followed by sustained participation, whilst maintaining all current areas of operations, 
thus keeping with the co-founders’ original vision for British Universities Ice Hockey with consideration for the wishes of its current members.
\n
The Coronavirus Pandemic was a major hurdle, with activity halting for almost 2 full seasons. The BUIHA committee has been working to ensure the future of the 
association and the sport. The 21-22 season saw a return to regular cup competiton and nationals play.
\n

## Women's University Ice Hockey
The BUIHA have welcomed the recent expansion of Women’s Ice Hockey teams. Until 2016, only the Oxbridge clubs operated women’s-only teams and have done so for decades.

This was followed by Sheffield Bears and Nottingham Mavericks, with the Caledonia Steel Queens being founded as the first women’s-only universities Ice Hockey team in Scotland before moving to the WNIHL.
\n
In recent years this has grown to most BUIHA clubs either having their own women’s-only team or having access to a women’s-only university team nearby.
\n
The 24-25 season saw the introduction of a dedicated Womens Cup, being introduced in phases following a meeting of women's team representatives at Womens Nationals 2024. 

## Inactive Clubs

Today more than 20 clubs are active within the BUIHA, each with their own unique history and story.
There are several more which have been inactive for a number of years. The BUIHA is always looking to help new clubs form and existing clubs to grow. If you are interested in starting a new club or revitalising an inactive one, please get in touch.


- Anglia Ruskin Rangers
- Bradford Sabres
- Caledonia Steel Queens (Moved to WNIHL)
- Durham Knights
- Huddersfield Ice Hawks
- Liverpool Lightning
- LJMU Leopards
- Surrey Sharks
- UCLan Huskies

`,
    };
    export default history;